const primaryMain = '#990000';
const primaryMainOpacity = 'rgba(53, 0, 0, 0.9)';
const secondaryMain = '#000000';
const secondaryMainOpacity = 'rgba(0, 0, 0, 0.5)';
const secondaryLight = '#D52027';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
